import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "sonner";
import { CheckCircle2 } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";

export default function ComplaintFormPage() {
  const { token } = useParams();
  const [info, setInfo] = useState(null);
  const [error, setError] = useState(null);
  const [text, setText] = useState("");
  const [saving, setSaving] = useState(false);
  const [done, setDone] = useState(false);
  useEffect(() => {
    api.get(`/complaint-forms/respond/${token}`).then((r) => setInfo(r.data))
      .catch((e) => setError(formatApiErrorDetail(e.response?.data?.detail) || e.message));
  }, [token]);
  const submit = async () => {
    setSaving(true);
    try { await api.post(`/complaint-forms/respond/${token}`, { description: text }); setDone(true); }
    catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || e.message); }
    finally { setSaving(false); }
  };
  if (error) return <div className="min-h-screen bg-slate-50 flex items-center justify-center p-6"><div className="max-w-md bg-white border border-slate-200 p-8 text-center text-sm text-slate-600" data-testid="complaint-form-error">{error}</div></div>;
  if (!info) return <div className="min-h-screen flex items-center justify-center text-xs text-slate-400">Lädt…</div>;
  const thanks = done || info.already_submitted;
  return (
    <div className="min-h-screen bg-slate-50 flex items-start justify-center p-4 sm:p-8">
      <div className="w-full max-w-xl bg-white border border-slate-200" data-testid="complaint-form-page">
        <div className="px-6 sm:px-8 py-6 border-b border-slate-100">
          <img src={`${process.env.REACT_APP_BACKEND_URL}/api/assets/logo-email.png`} alt="Logo" className="h-9 mb-5" data-testid="complaint-form-logo" />
          <div className="text-[10px] font-bold uppercase tracking-overline text-slate-500 mb-1">Beschwerdebogen</div>
          <div className="font-heading text-2xl font-light tracking-tighter text-slate-900">{thanks ? "Vielen Dank!" : `Hallo${info.first_name ? " " + info.first_name : ""}.`}</div>
        </div>
        <div className="px-6 sm:px-8 py-6">
          {thanks ? (
            <div className="p-6 bg-emerald-50 border border-emerald-200 text-center flex flex-col items-center gap-2" data-testid="complaint-form-done">
              <CheckCircle2 size={32} strokeWidth={1.5} className="text-emerald-600" />
              <div className="font-medium text-emerald-800">Ihr Anliegen wurde übermittelt.</div>
              <div className="text-xs text-emerald-700">Wir kümmern uns darum und melden uns bei Ihnen.</div>
            </div>
          ) : (
            <div className="space-y-4">
              <label className="text-sm text-slate-800 block">Beschreibung Ihres Anliegens
                <textarea rows={8} value={text} onChange={(e) => setText(e.target.value)} className="input-tech resize-none mt-2" data-testid="complaint-form-text" />
              </label>
              <button onClick={submit} disabled={saving || text.trim().length < 5} data-testid="complaint-form-submit"
                className="w-full bg-slate-900 text-white py-4 text-sm font-medium hover:bg-black disabled:opacity-40 transition-colors">{saving ? "Sendet…" : "Absenden"}</button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
